import _jsx from '@babel/runtime/helpers/jsx';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import 'react';
import 'prop-types';
import { Image } from 'frontend-image';
import { ExpandableSection } from '@andes/expandable-section';
import { AndesProvider } from '@andes/context';
import { jsx } from 'react/jsx-runtime';
var _span;
const KeywordSummaryMobile = _ref => {
  let {
    jsDisabled,
    title,
    description,
    image,
    expandableProps,
    charCountToExpand = 252,
    locale
  } = _ref;
  const namespace = 'seo-ui-keyword-summary-mobile';
  const {
    altImage,
    imageUrl,
    fallbackImage,
    preload = false,
    lazyload = false
  } = image;
  const {
    expansionText,
    contractionText,
    size,
    defaultHeight,
    color
  } = expandableProps || {};
  const finalImageUrl = imageUrl ? imageUrl : fallbackImage;
  const isLazyLoad = lazyload ? 'on' : 'off';
  const onLoadImage = jsDisabled ? 'off' : 'on';
  const removeHtmlTags = input => {
    return input.replace(/<[^>]*>/g, '');
  };
  const charCount = removeHtmlTags(description).length;
  const renderLongDescription = () => {
    const optionalSimpleProps = _objectSpread(_objectSpread(_objectSpread({}, expansionText !== undefined ? {
      expansionText
    } : {}), contractionText !== undefined ? {
      contractionText
    } : {}), color !== undefined ? {
      color
    } : {});
    const componentProps = _objectSpread({
      id: "".concat(namespace, "__expandable-section"),
      defaultHeight,
      simple: optionalSimpleProps
    }, size !== undefined ? {
      size
    } : {});
    return /*#__PURE__*/jsx(ExpandableSection, _objectSpread(_objectSpread({}, componentProps), {}, {
      children: /*#__PURE__*/_jsx("div", {
        className: "".concat(namespace, "__expandable-htlm-content")
        // eslint-disable-next-line react/no-danger
        ,

        dangerouslySetInnerHTML: {
          __html: description
        }
      })
    }));
  };
  const renderShortDescription = () => {
    return /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__htlm-content")
      // eslint-disable-next-line react/no-danger
      ,

      dangerouslySetInnerHTML: {
        __html: description
      }
    });
  };
  const renderDescription = () => {
    return charCount >= charCountToExpand ? /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__description-container")
    }, void 0, renderLongDescription()) : /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__description-container")
    }, void 0, renderShortDescription());
  };
  return /*#__PURE__*/_jsx(AndesProvider, {
    locale: locale
  }, void 0, /*#__PURE__*/_jsx("section", {
    className: "".concat(namespace)
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__container")
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__header-container")
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__image-container")
  }, void 0, _span || (_span = /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace, "__image-overlay")
  })), /*#__PURE__*/_jsx(Image, {
    className: "".concat(namespace, "__image"),
    src: finalImageUrl,
    srcFallback: fallbackImage,
    lazyload: isLazyLoad,
    preload: preload,
    fetchPriority: preload ? 'high' : null,
    onload: onLoadImage,
    alt: altImage
  })), /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__title-container")
  }, void 0, /*#__PURE__*/_jsx("h3", {
    className: "".concat(namespace, "__title")
  }, void 0, title))), renderDescription())));
};
KeywordSummaryMobile.displayName = 'KeywordSummaryMobile';
export { KeywordSummaryMobile as default };
